import React, {useContext} from "react";
import {useSortable} from "@dnd-kit/sortable";
import {GridRow, GridRowProps} from "@mui/x-data-grid";
import {Box} from "@bounce/shared/ui";
import {DndEnabledContext, RowHandleContext, getSortableRowStyle} from "../../components/sortable";
import {SegmentTypeSeparatorContext} from "./SegmentDndContext";
import {SegmentTypeSeparator} from "./SegmentTypeSeparator";

export const SortableSegmentRow = (props: GridRowProps) => {
  const enabled = useContext(DndEnabledContext);
  const {firstGeneralId, isBlocked} = useContext(SegmentTypeSeparatorContext);
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.rowId,
    disabled: !enabled,
  });

  const style = getSortableRowStyle(props.style, {transform, transition, isDragging});

  const row = (
    <RowHandleContext.Provider value={{attributes, listeners}}>
      <GridRow ref={setNodeRef} {...props} style={style} />
    </RowHandleContext.Provider>
  );

  if (props.rowId !== firstGeneralId) return row;

  return (
    <Box role="presentation" sx={{position: "relative", display: "flow-root"}}>
      <SegmentTypeSeparator isBlocked={isBlocked} />
      {row}
    </Box>
  );
};
